<template>
    <form ref="form" v-on="formEvents">
        <div class="form-group">
            <label>Merchant</label>
            <input @keyup="showForm" required type="text" v-model="form.merchant" value=""
                   :class="[ 'form-control' , form.errors.get('merchant') ? 'is-invalid' : '' ]"
                   placeholder="Enter Merchant Number">
            <div v-text="form.errors.get('merchant')" class="invalid-feedback"/>
        </div>

        <transition name="slide-in-top">
            <div v-if="formVisibility">
                <div class="form-group">
                    <label>Reference</label>
                    <input type="text" v-model="form.reason" value=""
                           :class="[ 'form-control' , form.errors.get('reason') ? 'is-invalid' : '' ]" placeholder="">
                    <div v-text="form.errors.get('reason')" class="invalid-feedback"/>
                </div>

                <div class="form-group">
                    <label>Beneficiary Phone Number </label>
                    <phone-input v-model="form.phone"></phone-input>
                    <div v-text="form.errors.get('phone')" class="text-danger"/>
                    <small>* Also used for notifications</small>
                </div>

                <div class="form-group">
                    <label>Pay with</label>
                    <select v-model="form.payment"
                            :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                        <option v-if="isEcocashZwgEnabled" value="ecocash">EcoCash ZWG</option>
                        <option v-if="isEcocashUsdEnabled" value="ecocash-usd">EcoCash USD</option>
                        <option v-if="isStripeEnabled" value="stripe">International Card</option>
                    </select>
                    <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                </div>

                <div v-if="form.payment === 'ecocash'" class="form-group">
                    <label>EcoCash Phone Number</label>
                    <phone-input v-model="form.ecocash" :countries="['ZW']"></phone-input>
                    <div v-text="form.errors.get('ecocash')" class="text-danger"/>
                </div>

                <div class="form-group">
                    <label>Amount</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        {{ methods[form.payment] }}
                    </span>
                        </div>
                        <input type="number" v-model="form.amount"
                               :class="[ 'form-control' , form.errors.get('amount') ? 'is-invalid' : '' ]"
                               placeholder="Amount">
                        <div v-text="form.errors.get('amount')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="form-group d-flex align-items-center">
                    <input type="checkbox" class="mr-2" id="checkterms" v-model="termsAccepted">
                    <label class="mb-0" for="checkterms">I accept the <a target="_blank" href="/terms">Terms & Conditions</a></label>
                </div>
            </div>
        </transition>

        <div class="form-group">
            <button @click="formVisibility ? submit($event) : (formVisibility = true)"
                    type="button"
                    v-bind="buttonValidity"
                    :class="{'btn-loading': form.loading, ...buttonValidity.class }">Pay Bill
            </button>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import PhoneInput from "../../custom/phone-input.vue";
import {validity} from "../../../core/forms/validity";
import {appDataMixin, paymentMethods, systems} from "../../../core/data/global";

export default {
    name: "dashboard",
    mixins: [validity, appDataMixin],
    components: {PhoneInput},
    data: function () {
        return {
            meterLoading: false,
            fields: [
                'reason',
                'phone',
                'amount',
                'currency',
                'merchant',
                'ecocash'
            ],
            methods: {
                'ecocash': 'ZWG',
                'stripe': 'USD',
                'ecocash-usd': 'USD',
            },
            meter: {},
            bundles: [],
            categories: [],
            rate: 1,
            discount: 1,
            loading: false,
            form: new Form({
                'type': 'bill',
                'reason': '',
                'payment': 'ecocash',
                'phone': '',
                'ecocash': '',
                'amount': '',
                'merchant': '',
            })
        };
    },
    computed: {
        isEcocashZwgEnabled() {
            return systems.ecocash_payment && systems.ecocash_zwg_payment;
        },
        isEcocashUsdEnabled() {
            return systems.ecocash_payment && systems.ecocash_usd_payment;
        },
        isEcocashEnabled() {
            return this.isEcocashZwgEnabled || this.isEcocashUsdEnabled;
        },
        isStripeEnabled() {
            return paymentMethods.includes('stripe');
        }
    },
    methods: {
        saveToLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                localStorage.setItem(`telone-${this.fields[i]}`, this.form[this.fields[i]]);
            }
        },
        getFromLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {

                let value = localStorage.getItem(`telone-${this.fields[i]}`);
                if (value != null && value !== "" && value !== "null") {
                    this.form[this.fields[i]] = value;
                }
            }
        },

        submit(event) {
            // Save to Local Storage

            if (this.$refs.form.checkValidity() && !this.form.errors.any()) {
                event.preventDefault();

                this.saveToLocalStorage();
                this.form.submit('/telone/init').then((response) => {
                    if (response.data.success) {
                        if (response.data.body.payment.payment === "ecocash" || response.data.body.payment.payment === "ecocash-usd") {
                            this.$router.push(`/telone/ecocash?id=${response.data.body.payment.ref}`);
                        }

                        if (response.data.body.payment.payment === "stripe") {
                            window.location.href = response.data.body.payment.url;
                        }

                    } else {

                    }
                });
            }
        }
    },

    mounted() {
        this.scrollToTop();
        this.getFromLocalStorage();
    }
}
</script>

<style scoped>

</style>
